
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { ExtraRegistrationField } from "@/model/ExtraRegistrationField";
import { ILookupItem, LookupItem } from "@/model/LookupItem";
import { RegistrationFieldType } from "@/model/Enums";

@Component({ components: { } })
export default class FieldDependencyDialogue extends Vue {

    @Prop({ required: true })
    value!: boolean;

    @Prop({ required: true })
    field!: ExtraRegistrationField | null;

    @Prop({ required: true })
    fieldList!: Array<ExtraRegistrationField>;

    shouldAlwaysShow: boolean = true;
    selectedFieldKey: string = "";
    selectedFieldValue: string = "true";

    get title(): string {
        return `Conditionally show: ${this.field?.label ?? "- - -"} `;
    }

    get alwaysShowRadioIcon(): string {
        return this.shouldAlwaysShow ? "mdi-radiobox-marked" : "mdi-radiobox-blank";
    }

    get conditionalShowRadioIcon(): string {
        return this.shouldAlwaysShow ? "mdi-radiobox-blank" : "mdi-radiobox-marked";
    }

    get fieldOptions(): Array<ILookupItem> { 
        return this.fieldList
            .filter(i => i.key !== this.field?.key && i.fieldType === RegistrationFieldType.YesNo)
            .map(i => LookupItem.createLookup(i.key, i.label)); 
    }

    get infoMessage() : string {
        return this.field?.fieldType === RegistrationFieldType.YesNo
            ? "You can't conditionally show or hide a Yes/No field."
            : "There are no Yes / No fields available to be dependent upon."
    }

    @Watch("field", { immediate: true, deep: false })
    onFieldChanged() {
        const isDependency = this.field?.showIf.hasValue;
        this.selectedFieldKey = isDependency 
            ? this.field?.showIf.key ?? ""
            : "";
        this.selectedFieldValue = isDependency 
            ? this.field?.showIf.value ?? ""
            : "";
        this.shouldAlwaysShow = !isDependency;
    }

    @Watch("shouldAlwaysShow", { immediate: false, deep: false })
    onAlwaysShowChange() {
        if(this.shouldAlwaysShow) {
            this.$emit("changed", this.field, "", "");
        }
        else {
            this.$emit("changed", this.field, this.selectedFieldKey, this.selectedFieldValue);
        }
    }

    @Watch("selectedFieldKey", { immediate: false, deep: false })
    onKeyChange() {
        this.$emit("changed", this.field, this.selectedFieldKey, this.selectedFieldValue);
    }

    @Watch("selectedFieldValue", { immediate: false, deep: false })
    onValueChange() {
        this.$emit("changed", this.field, this.selectedFieldKey, this.selectedFieldValue);
    }

    close() {
        this.$emit("input", false);
    }

}
